module.exports = __webpack_public_path__ + "img/margot-set-complet.8d81077b.jpg";